import React from "react";
import "../scss/App.scss";
import thumb from "../assets/egle-photo.jpg";
import SocialLinks from "./SocialLinks";

const About = (props) => {
  return (
    <div className="about-me">
        <h2>About me</h2>
        <div className="flex-container">            
            <div className="animation-about"><img src={thumb}></img></div>
            <div className="desc">
                <h5>Hi! I am Egle</h5>
                <p>Hello, I am Egle - a former Social Scientist who codes. This bold switch was driven by my passion for problem-solving and tangible results.
                I am actively looking for a JavaScript developer position. Willing to join a dynamic, innovative, collaborative team</p>
             <div className="aboutLinks"> <SocialLinks socials={props.socials}/></div>    
            </div>
           
        </div>
  </div>
  )
}

export default About;